// 是否关闭小窗模式
var close_mini_windows = false

function pwzr_() {
    try {
        if (!close_mini_windows) {
            let rio_media_gallery = document.querySelector('.rio-media-gallery')

            let rio_media_gallery_top = rio_media_gallery.getBoundingClientRect().top
            let header_offset_height = document.querySelectorAll(".shopify-section-header")[0].offsetHeight

            let product__media_list = rio_media_gallery.querySelectorAll('.pwzrswiper-slide')
            let thumbnail_slider = rio_media_gallery.querySelectorAll('.PwzrGrid-wrap-xs-nowrap')[0]

            let product_media_gallery_ele = rio_media_gallery.children[0]
            let slider_mobile_overlay_ele = rio_media_gallery.querySelectorAll('.pwzrjss109')[0]


            let pwzrjss2 = rio_media_gallery.querySelector('.pwzrjss2')

            if (rio_media_gallery_top - header_offset_height <= 0) {
                thumbnail_slider.classList.add('thumbnail_slider_none')
                rio_media_gallery.classList.add('block_top')
                product_media_gallery_ele.classList.add('fixed_product_media_wrapper_mini')
                slider_mobile_overlay_ele.classList.add('cus___ma_K')
                pwzrjss2.classList.add('pwzrjss2_top_0')
                product__media_list.forEach(item => {
                    item.classList.add('product_media_wrapper_mini')
                })

            } else {
                thumbnail_slider.classList.remove('thumbnail_slider_none')
                rio_media_gallery.classList.remove('block_top')
                product_media_gallery_ele.classList.remove('fixed_product_media_wrapper_mini')
                slider_mobile_overlay_ele.classList.remove('cus___ma_K')
                pwzrjss2.classList.remove('pwzrjss2_top_0')
                product__media_list.forEach(item => {
                    item.classList.remove('product_media_wrapper_mini')
                })
            }

            let ele_bottom = document.getElementById('product_8nnuqwe_jioqjwe').getBoundingClientRect().bottom
            if (ele_bottom < 400) {
                product_media_gallery_ele.classList.add('product_media_wrapper_show')
            } else {
                product_media_gallery_ele.classList.remove('product_media_wrapper_show')
            }
        }
    } catch (e) {
        console.log(e)
        console.log("小图模式异常")
    }
}

document.addEventListener('scroll', function (event) {
    // 防止视频被暂停
    document.querySelectorAll("video").forEach(video => {
        if (video.paused) {
            video.play().then(() => {
            }).catch(error => {
                console.error("播放失败:", error);
            });
        }
    })


    if (window.innerWidth <= 480) {
        pwzr_()
    }

    // if (window.innerWidth <= 480) {
    //     let product__media_wrapper_main = document.getElementById('product__media_wrapper_main')
    //
    //     let product_media_wrapper_top = product__media_wrapper_main.getBoundingClientRect().top
    //     let header_offset_height = document.querySelectorAll(".shopify-section-header")[0].offsetHeight
    //
    //     let product__media_list = document.getElementById('product__media_wrapper_main').querySelectorAll('.product__media')
    //     let thumbnail_slider = document.getElementById('product__media_wrapper_main').querySelectorAll('.thumbnail-slider')[0]
    //
    //
    //     let product_media_gallery_ele = product__media_wrapper_main.querySelectorAll('.product__media-gallery')[0]
    //     let use_animate_ele = product__media_wrapper_main.querySelectorAll('use-animate')[0]
    //     let product_media_list_ele = product__media_wrapper_main.querySelectorAll('.product__media-list')[0]
    //     let slider_mobile_overlay_ele = product__media_wrapper_main.querySelectorAll('.slider-mobile--overlay')[0]
    //
    //     if (product_media_wrapper_top - header_offset_height <= 0) {
    //         thumbnail_slider.classList.add('thumbnail_slider_none')
    //         product__media_wrapper_main.classList.add('block_top')
    //         product_media_gallery_ele.classList.add('fixed_product_media_wrapper_mini')
    //         slider_mobile_overlay_ele.classList.add('cus___ma_')
    //         product__media_list.forEach(item => {
    //             item.classList.add('product_media_wrapper_mini')
    //         })
    //
    //     } else {
    //         thumbnail_slider.classList.remove('thumbnail_slider_none')
    //         product__media_wrapper_main.classList.remove('block_top')
    //         product_media_gallery_ele.classList.remove('fixed_product_media_wrapper_mini')
    //         slider_mobile_overlay_ele.classList.remove('cus___ma_')
    //         product__media_list.forEach(item => {
    //             item.classList.remove('product_media_wrapper_mini')
    //         })
    //     }
    //
    //     let ele_bottom = document.getElementById('product_8nnuqwe_jioqjwe').getBoundingClientRect().bottom
    //     if (ele_bottom < 400) {
    //         product_media_gallery_ele.classList.add('product_media_wrapper_show')
    //     } else {
    //         product_media_gallery_ele.classList.remove('product_media_wrapper_show')
    //     }
    //
    // }


    // 滑动到底部，加入购物车的悬浮层隐藏
    let cus_product_sticky_cart = document.querySelector(".cus_product-sticky-cart")
    if (window.innerHeight + document.documentElement.scrollTop + 50 >= document.documentElement.scrollHeight) {
        cus_product_sticky_cart.classList.add('cus_product-sticky-cart_downturn')
    } else {
        cus_product_sticky_cart.classList.remove('cus_product-sticky-cart_downturn')
    }

});

function monitor_pwzriss1() {
    const targetNode = document.querySelector('.pwzrjss1');
    const config = {childList: true, subtree: true, characterData: true};
    const callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.id === 'pwzrswiper-container-wrapper') {
                        let rio_media_gallery = document.querySelector('.rio-media-gallery')

                        let rio_media_gallery_top = rio_media_gallery.getBoundingClientRect().top
                        let header_offset_height = document.querySelectorAll(".shopify-section-header")[0].offsetHeight

                        let product__media_list = node.querySelectorAll('.pwzrswiper-slide')

                        if (rio_media_gallery_top - header_offset_height <= 0) {
                            product__media_list.forEach(item => {
                                item.classList.add('product_media_wrapper_mini')
                            })
                        }
                    }
                })
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

let pwzrjss1Attempts = 0
const pwzrjss1IntervalId = setInterval(() => {
    pwzrjss1Attempts++;

    const targetNode = document.querySelector('.pwzrjss1');
    console.log("targetNode", targetNode)
    if (targetNode) {
        monitor_pwzriss1()
        clearInterval(pwzrjss1IntervalId)
    }

    if (pwzrjss1Attempts > 20) {
        close_mini_windows = true
        clearInterval(pwzrjss1IntervalId)
    }

}, 50);

